import SearchBarFilter from '@/platform/common/components/SearchBarFilter/SearchBarFilter';
import { useFilters } from '@/platform/hooks/useFilters';
import {
    Container,
    FilterBarDropdown,
    Segment,
    SegmentContent,
    SegmentHeader,
    Table,
    TableBody,
    TableCell,
    TableRow,
} from '@/platform/ui';
import { usePage } from '@inertiajs/react';
import { ArcElement, Chart as ChartJS, Legend, Tooltip } from 'chart.js';
import { Pie } from 'react-chartjs-2';
import Navigation from './components/Navigation';

ChartJS.register(ArcElement, Legend, Tooltip);

const DashboardView = () => {
    const { auth, sroi, not_sroi, categories, years } = usePage().props;
    const { filters, updateFilters } = useFilters([
        'sroi',
        'not_sroi',
        'categories',
    ]);

    return (
        <Container fluid>
            <Navigation />

            <SearchBarFilter only={['sroi', 'not_sroi', 'categories']}>
                <FilterBarDropdown
                    multiple
                    selectAll
                    label={`Entiteiten (${filters?.entity_ids?.length || 0}/${auth?.customer?.entities?.length || 0})`}
                    options={auth.customer?.entities?.map(entity => ({
                        id: entity.id,
                        name: entity.name,
                    }))}
                    value={filters?.entity_ids || []}
                    onChange={value => updateFilters('entity_ids', value)}
                />
                <FilterBarDropdown
                    label={filters?.year}
                    options={years || []}
                    value={filters?.year || []}
                    onChange={value => updateFilters('year', value)}
                />
            </SearchBarFilter>

            <div className='grid grid-cols-1 items-start gap-4 md:grid-cols-2'>
                <Segment className='not-last:mb-0'>
                    <SegmentHeader header='Aantal unieke werknemers' />
                    <SegmentContent>
                        <div className='mx-auto my-6 max-w-[350px]'>
                            <Pie
                                data={{
                                    labels: ['SROI', 'Niet SROI'],
                                    datasets: [
                                        {
                                            data: [sroi || 0, not_sroi || 0],
                                            backgroundColor: [
                                                '#06224c',
                                                '#74cdff',
                                            ],
                                        },
                                    ],
                                }}
                                options={{
                                    plugins: {
                                        legend: {
                                            position: 'bottom',
                                        },
                                    },
                                }}
                            />
                        </div>
                    </SegmentContent>
                </Segment>
                <Segment className='not-last:mb-0'>
                    <SegmentHeader header='Aantal positieve reacties' />
                    <SegmentContent>
                        <Table striped>
                            <TableBody>
                                {categories?.map(category => (
                                    <TableRow key={category.value}>
                                        <TableCell className='font-semibold'>
                                            {category.label}
                                        </TableCell>
                                        <TableCell textAlign='right'>
                                            {category.counts}
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </SegmentContent>
                </Segment>
            </div>
        </Container>
    );
};

export default DashboardView;
